export default "__VITE_ASSET__BHbyGIVZ__"